import { useImageMasonryWithLazyLoad } from "./utils/eq-image.js";
const Swiper = require("swiper");
export function homepage() {
  useImageMasonryWithLazyLoad();
  var movieSwiper = new Swiper.default(".swiper-container-movie", {
    slidesPerView: 1,
    spaceBetween: 10,
    grabCursor: true,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 2300,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 30,
      },
    },
  });
  var mvSwiper = new Swiper.default(".swiper-container-mv", {
    slidesPerView: 1,
    spaceBetween: 10,
    grabCursor: true,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 2800,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });
}

export function landingPage() {
  document.addEventListener("DOMContentLoaded", function() {
    const destinationUrl = decodeURIComponent(Equipment.data.dest_url);
    const token = Equipment.data.token;
    const employee_status = Equipment.data.employee_status;
    if (employee_status !== "quit") {
      const redirectDelay = 1000;
      setTimeout(function() {
        let finalRedirectUrl = destinationUrl;
        if (finalRedirectUrl.includes("?")) {
          finalRedirectUrl += "&token=" + encodeURIComponent(token);
        } else {
          finalRedirectUrl += "?token=" + encodeURIComponent(token);
        }

        window.location.href = finalRedirectUrl;
      }, redirectDelay);
    }
  });
}
